var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedShadow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 114,
    viewBox: "0 0 112 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87698 40.1364C-11.0411 29.043 39.0982 43.1953 49.0435 12.051C59.3616 -20.2606 107.576 22.7316 111.284 35.5976L111.294 35.6139C111.286 35.5963 111.277 35.5774 111.303 35.6277C111.302 35.6283 111.302 35.6288 111.301 35.6293C111.301 35.6308 111.302 35.6311 111.301 35.6296C78.7838 63.6004 106.498 96.5294 99.7683 109.926C91.3563 126.672 58.6277 79.9338 62.8169 60.4686C69.5231 29.3083 16.795 51.2298 2.87698 40.1364Z",
    fill: "url(#paint0_linear_619_1754)",
    fillOpacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_619_1754",
    x1: 52.7662,
    y1: 110.791,
    x2: 119.107,
    y2: 5.40798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97171",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedShadow);
export default __webpack_public_path__ + "static/media/RedShadow.556776ce8e1970bdaf5c72db7ce07658.svg";
export { ForwardRef as ReactComponent };